import {createSelector} from '@reduxjs/toolkit'

export const getModalStack = state => state.modal.stack